import style from './index.less';

export default () => {
    return (
        <div className={style.qrcode}>
            <div>百度智能云APP/百度APP/网盘</div>
            <div>扫描二维码登录</div>
        </div>
    );
};
